import { useShareMailboxContext } from '@utils';
import { getIsOnPremises, getMailId, getUserEmail, ReportType } from '@utils-global';
import { useReportMailFlow } from '../../../hooks';

export const useSpamReport = () => {
  const { isSharedMailbox, sharedProperties, originalUserEmail } = useShareMailboxContext();

  const mailId = getMailId();
  const isOnPremises = getIsOnPremises();
  const mailboxEmail =
    isSharedMailbox && sharedProperties?.targetMailbox
      ? sharedProperties.targetMailbox
      : getUserEmail();

  const { isLoading, report, handleReport, resetReport } = useReportMailFlow({
    mailId,
    mailboxEmail,
    isSharedMailbox,
    originalUserEmail,
    actionsTaken: [], // Spam reports don't have action taken
    isOnPremises,
    reportType: ReportType.SPAM,
  });

  return {
    isLoading,
    report,
    handleReport,
    resetReport,
  };
};
